import React, { useRef, useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Requestcallback } from "./MultipleComp";

const RightSideButton = (props) => {
  const [showHide, setShowHide] = useState(false);
  const [showHide1, setShowHide1] = useState(false);
  const [showChatBot, setShowChatBot] = useState(false);
  const [showChatBotIcon, setShowChatBotIcon] = useState(false);
  const [device, setDevice] = useState("");
  // Toggle: true = hitechbot (new experience), false = haptic (old experience)
  const [useNewBot, setUseNewBot] = useState(() => {
    const saved = localStorage.getItem("chatbot_experience");
    // Default to false (Haptic) when no preference is saved
    return saved === "new";
  });

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    console.log("userAgent");
    // iOS detection
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      setDevice("https://apple.co/4cFgq9t");
    }
    // Android detection
    else if (/android/i.test(userAgent)) {
      setDevice("https://bit.ly/3WueY3B");
    } else {
      setDevice("https://bit.ly/3WueY3B");
    }

    const params = new URLSearchParams(window.location.search);

    if (params.get("bot") === "betaAJBHBUIE9237062062383T7YFWD698W7368") {
      localStorage.setItem("chatbot_beta", "true");
    }

    if (localStorage.getItem("chatbot_beta") === "true") {
      setShowChatBotIcon(true);
    }
  }, []);

  const handleBotToggle = () => {
    const newValue = !useNewBot;
    setUseNewBot(newValue);
    localStorage.setItem("chatbot_experience", newValue ? "new" : "old");
  };

  // Always open the modal so toggle is accessible
  const handleChatBotClick = () => {
    setShowChatBot(!showChatBot);
  };

  const handleChatBotClose = () => {
    setShowChatBot(false);
  };

  const handleModalShowHide = () => {
    setShowHide(!showHide);
  };
  const handleModalShowHide1 = () => {
    setShowHide1(!showHide1);
  };
  return (
    <>
      <a href="/pay-emi" className="payonline-sec page-scroll">
        <img
          width="40"
          height="83"
          src={
            localStorage.getItem("language_id") == 0
              ? "/img/English_Pay.svg"
              : localStorage.getItem("language_id") == 1
                ? "/img/Hindi_Pay.svg"
                : localStorage.getItem("language_id") == 2
                  ? "/img/Gujrati_Pay.svg"
                  : localStorage.getItem("language_id") == 3
                    ? "/img/Marathi_Pay.svg"
                    : "/img/English_Pay.svg"
          }
          alt="Pay online"
        />
      </a>

      {window.location.href.includes("landing") ? (
        <>
          <div
            onClick={(e) => {
              const quote = document.getElementById("quote_landing");
              const to = quote.offsetTop - 100;
              window.scrollTo(0, to);
            }}
            className="applynow-sec page-scroll"
          >
            <img
              width="40"
              height="83"
              src={
                localStorage.getItem("language_id") == 0
                  ? "/img/apply-now.svg"
                  : localStorage.getItem("language_id") == 1
                    ? "/img/apply_now_Hindi-CTA.png"
                    : localStorage.getItem("language_id") == 2
                      ? "/img/apply_now_Gujarati-CTA.png"
                      : localStorage.getItem("language_id") == 3
                        ? "/img/apply_now_Marathi-CTA.png"
                        : "/img/apply-now.png"
              }
              alt="Apply Now"
            />
          </div>
        </>
      ) : (
        <>
          {console.log("Hello else")}
          <div
            onClick={() => {
              handleModalShowHide();
            }}
            className="applynow-sec"
          >
            <img
              width="40"
              height="83"
              src={
                localStorage.getItem("language_id") === 0 ||
                  localStorage.getItem("language_id") === "0"
                  ? "/img/apply-now.svg"
                  : localStorage.getItem("language_id") === 1 ||
                    localStorage.getItem("language_id") === "1"
                    ? "/img/apply_now_Hindi-CTA.png"
                    : localStorage.getItem("language_id") === 2 ||
                      localStorage.getItem("language_id") === "2"
                      ? "/img/apply_now_Gujarati-CTA.png"
                      : localStorage.getItem("language_id") === 3 ||
                        localStorage.getItem("language_id") === "3"
                        ? "/img/apply_now_Marathi-CTA.png"
                        : "/img/apply-now.png"
              }
              alt="Apply Now"
            />
          </div>
        </>
      )}
      <Modal
        className="callback-modal"
        size="lg"
        centered="true"
        show={showHide}
      >
        <Modal.Header
          closeButton
          onClick={() => handleModalShowHide()}
        ></Modal.Header>
        <Requestcallback />
      </Modal>

      {/* Desktop Visible */}
      <a href="/connector-onboarding" className="partner-sec dblock mnone">
        {/* Become a partner */}

        <img
          width="40"
          height="83"
          src={
            localStorage.getItem("language_id") == 0
              ? "/img/be_partner_english.svg"
              : localStorage.getItem("language_id") == 1
                ? "/img/be_partner_hindi.svg"
                : localStorage.getItem("language_id") == 2
                  ? "/img/be_partner_gujrati.svg"
                  : localStorage.getItem("language_id") == 3
                    ? "/img/be_partner_english.svg"
                    : "/img/be_partner_english.svg"
          }
          alt="Connector Onboading"
        />
      </a>

      {/* Mobile Visible */}
      <a href={device} className="partner-sec dnone mblock">
        {/* Become a partner */}
        <img
          width="40"
          height="83"
          src={
            localStorage.getItem("language_id") == 0
              ? "/img/be_partner_english.svg"
              : localStorage.getItem("language_id") == 1
                ? "/img/be_partner_hindi.svg"
                : localStorage.getItem("language_id") == 2
                  ? "/img/be_partner_gujrati.svg"
                  : localStorage.getItem("language_id") == 3
                    ? "/img/be_partner_english.svg"
                    : "/img/be_partner_english.svg"
          }
          alt="Connector Onboading"
        />
      </a>

      {/* <a
        aria-label="toll free"
        href="/connector-onboarding"
        className="tollfree-sec"
      >
        <img src="/img/tollfree1.png" width="45" height="144" alt="" />
      </a> */}
      <div
        onClick={() => {
          handleModalShowHide1();
        }}
        className="chat-sec desk-chat"
      >
        <img
          src="/img/whatsapp-ico.png"
          width="45"
          height="45"
          alt="Chat & Apply"
        />
      </div>

      <div
        onClick={handleChatBotClick}
        className="ai-chat-2"
      >
        <img
          src="/img/haptic_chatboat_custom_icons.png"
          width="90"
          height="45"
          alt="Chat & Apply"
        />
      </div>
      <a
        href="https://wa.me/919289182985/?text=Hi"
        className="chat-sec mob-chat"
      >
        <img src="/img/whatsapp-ico.png" alt="Chat & Apply" />
      </a>
      <Modal className="chat-modal" centered="true" show={showHide1}>
        <Modal.Header
          closeButton
          onClick={() => handleModalShowHide1()}
        ></Modal.Header>
        <div className="whatapp_barcode row">
          <div className="col-md-6 col-border">
            <div className="whatapp_text">
              WhatsApp <strong>'Hi'</strong>
              <br /> on <br />
              <strong>92891 82985</strong>
              <br /> to apply!
            </div>
          </div>
          <div className="col-md-6">
            <div className="whatapp_bar">
              OR <br />
              <strong>Scan</strong> & say <strong>'Hi'</strong>
              <br />
              <img src="/img/whatApp_barcode.png" alt="Chat & Apply" />
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        show={showChatBot}
        onHide={handleChatBotClose}
        dialogClassName="chatbot-right-modal"
        backdrop={false}
        style={{ zIndex: 9999 }}
      >
        <Modal.Header closeButton style={{ position: "relative", zIndex: 11111111, background: "white" }}>
          <div className="chatbot-header-content">
            {useNewBot ? (<img
              src="/hitechbotpic.png"
              width="45"
              height="45"
              alt="Chat & Apply"
            />) : (<img
              src="/img/haptic_chatboat_custom_icons.png"
              width="90"
              height="45"
              alt="Chat & Apply"
            />)}
            <div>
              <Modal.Title>Hero Housing Finance</Modal.Title>
              <div className="chatbot-toggle-wrapper">
                <label className="chatbot-switch" htmlFor="botToggle">
                  <input
                    type="checkbox"
                    id="botToggle"
                    checked={useNewBot}
                    onChange={handleBotToggle}
                  />
                  <span className="chatbot-slider"></span>
                </label>
                <span className="chatbot-toggle-label">Switch to {useNewBot ? "Old" : "New"} Experience</span>
              </div>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body style={{ padding: 0, position: "relative", height: "500px" }}>
          {useNewBot ? (
            <iframe
              src="https://hitechbot.herohfl.com"
              title="Agent Sage"
              width="100%"
              height="500"
              frameBorder="0"
              style={{
                border: "none",
                display: "block",
              }}
            />
          ) : (
            <iframe
              src="/haptic-embed.html"
              title="Haptic Chat"
              width="100%"
              height="550"
              frameBorder="0"
              style={{
                border: "none",
                display: "block",
                position: "absolute",
                top: "-64px",
                left: "0",
              }}
            />
          )}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default RightSideButton;
